// Neutral premium silhouette placeholder (SVG data URI).
// Same aspect ratio 4/5 as speaker photos so a real photo drops in with
// no layout shift.
const SILHOUETTE_DATA_URI =
  "data:image/svg+xml;charset=utf-8," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 500" preserveAspectRatio="xMidYMid slice">
      <defs>
        <linearGradient id="bg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stop-color="#12294F"/>
          <stop offset="1" stop-color="#0B1F3D"/>
        </linearGradient>
        <radialGradient id="glow" cx="0.5" cy="0.35" r="0.6">
          <stop offset="0" stop-color="#F5892E" stop-opacity="0.22"/>
          <stop offset="1" stop-color="#F5892E" stop-opacity="0"/>
        </radialGradient>
      </defs>
      <rect width="400" height="500" fill="url(#bg)"/>
      <rect width="400" height="500" fill="url(#glow)"/>
      <g fill="#F5EBD9" opacity="0.35">
        <circle cx="200" cy="200" r="70"/>
        <path d="M100,470 C100,370 130,320 200,320 C270,320 300,370 300,470 Z"/>
      </g>
      <g fill="none" stroke="#F5EBD9" stroke-opacity="0.15" stroke-width="1">
        <rect x="14" y="14" width="372" height="472"/>
      </g>
    </svg>`
  );

export default SILHOUETTE_DATA_URI;
